import axios from "../axiosPlugin.js";

export const getCouponTypeList = (data, loading = false, isDefaultAlertTips = false) => {
  return axios({
    url: "/api/couponType/list",
    method: "get",
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  });
};

export const getCouponTypeListForSelect = (data, loading = false, isDefaultAlertTips = false) => {
  return axios({
    url: "/api/couponType/listMap",
    method: "get",
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  });
};

export const getDepartment = (data, loading = false, isDefaultAlertTips = false) => {
  return axios({
    url: "/api/group/list",
    method: "get",
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  });
};

export const getPublicList = (data, loading = false, isDefaultAlertTips = false) => {
  return axios({
    url: "/api/couponType/publicList",
    method: "get",
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  });
};

export const approveCouponType = (data, loading = true) => {
  let queryString = data.cinemaId ? "cinemaId=" + data.cinemaId : "brandId=" + data.brandId;
  return axios({
    url: "/api/couponType/updateApprove?" + queryString,
    method: "post",
    data: {
      // data,
      loading,
    },
  });
};

export const deleteCouponType = (data, loading = true) => {
  return axios({
    url: "/api/couponType/delete/" + data.id,
    method: "delete",
    data: {
      data: {},
      loading
    },
  });
};

export const createCouponType = (data, loading = true) => {
  return axios({
    url: "/api/couponType/create",
    method: "post",
    data: {
      data,
      loading
    },
  });
};

export const getCouponTypeDetail = (data, loading = true, isDefaultAlertTips = false) => {
  return axios({
    url: "/api/couponType/detail/" + data.id,
    method: "get",
    data: {
      // data,
      loading,
      isDefaultAlertTips,
    },
  });
};

export const updateCoupon = (data, loading = true) => {
  return axios({
    url: "/api/couponType/update",
    method: "put",
    data: {
      data,
      loading
    },
  });
};

export const getCouponExchangeList = (data, loading = true) => {
  return axios({
    url: "/api/couponExchange/list",
    method: "get",
    data: {
      data,
      loading,
    },
  });
};

export const saveAllCouponExchange = (data, loading = true) => {
  return axios({
    url: "/api/couponExchange/saveAllCouponExchangeByCount",
    method: "get",
    data: {
      data,
      loading,
    },
  });
};

export const updateStatusCouponExchange = (data, loading = true) => {
  return axios({
    url: "/api/couponExchange/updateStatus?" + data,
    method: "post",
    data: {
      // data,
      loading,
    },
  });
};

export const updateAllCouponExchange = (data, loading = true) => {
  return axios({
    url: "/api/couponExchange/updateAllCouponExchangeStatusByCount",
    method: "get",
    data: {
      data,
      loading,
    },
  });
};
